import React from 'react'
import { BannerSection } from './components/BannerSection'
import { OnewayAndReturn } from './components/OnewayAndReturn'
import { SawariBenifits } from './components/SawariBenifits'
import { RecommendCars } from './components/RecommendCars'

export const MainAS = () => {
  return (
    <view  style={{ background: "#EDEEF0" }}>
    <BannerSection />
    <OnewayAndReturn />
    <SawariBenifits />
    <RecommendCars />
    </view>
  )
}
